export default "__VITE_ASSET__BMtg5kig__"